import { ModelType } from '@dimjs/model';
import { getFullUrlHref } from '../utils/path.js';

export type FabricLoadingState = {
  loading: {
    [routePath: string]: Record<string, number>;
  };
};

export type FabricLoadingActionParams = {
  show: { urlHref: string; id: string };
  hide: { urlHref: string; id: string; closeAll?: boolean };
};

function prepareLoadingCtx(state: FabricLoadingState, urlHref: string) {
  if (!state.loading[urlHref]) {
    state.loading[urlHref] = {};
  }
}

export const FabricFabricLoading: ModelType<
  FabricLoadingState,
  FabricLoadingActionParams
> = {
  actions: {
    show: ({ id, urlHref }) => {
      return (state) => {
        prepareLoadingCtx(state, urlHref);
        if (!state.loading[urlHref][id]) {
          state.loading[urlHref][id] = 1;
        } else {
          state.loading[urlHref][id] = state.loading[urlHref][id] + 1;
        }
      };
    },
    hide: ({ id, urlHref, closeAll = false }) => {
      return (state) => {
        prepareLoadingCtx(state, urlHref);
        if (!state.loading[urlHref][id]) {
          state.loading[urlHref][id] = 0;
        } else {
          state.loading[urlHref][id] = state.loading[urlHref][id] - 1;
        }
        if (state.loading[urlHref][id] < 0) {
          state.loading[urlHref][id] = 0;
        }
        if (closeAll) {
          state.loading[urlHref][id] = 0;
        }
      };
    },
  },
  state: {
    loading: {
      [getFullUrlHref()]: {},
    },
  },
};
